import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { isNil } from 'lodash-es';
import { RestService } from '@cumlaude/shared-services';
import { getDagenGeledenLabel } from '@cumlaude/shared-utils';
import { UserService } from '../../services/user.service';
import { AutorisatieService } from '../../services/autorisatie.service';
import { DashboardNavigatieService } from '../../services/dashboard-navigatie.service';
import { PaginaCardComponent } from '../../shared/components/pagina-card/pagina-card.component';

type RecentTegel = {
	url: string;
	titel: string;
	bovenschrift: string;
};

@Component({
	selector: 'app-recent-bekeken',
	templateUrl: './recent-bekeken.component.html',
	styleUrls: ['./recent-bekeken.component.scss'],
	imports: [PaginaCardComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecentBekekenComponent {
	private readonly restService = inject(RestService);
	private readonly autorisatieService = inject(AutorisatieService);
	private readonly dashboardNavigatie = inject(DashboardNavigatieService);
	private readonly userService = inject(UserService);
	private readonly router = inject(Router);

	private readonly recentePaginas = toSignal(
		toObservable(this.userService.activeRol).pipe(switchMap((rol) => (isNil(rol) ? of([]) : this.restService.getRecentePaginas(rol)))),
		{ initialValue: [] }
	);

	tegels = computed<RecentTegel[]>(() =>
		this.recentePaginas()
			.filter((pagina) => this.autorisatieService.isUrlAllowed(pagina.url))
			.map((pagina) => ({
				url: pagina.url,
				titel: pagina.naam,
				bovenschrift: getDagenGeledenLabel(new Date(pagina.laatstBezocht)),
			}))
	);

	open(url: string) {
		this.dashboardNavigatie.track('recent', url);
		this.router.navigateByUrl(url);
	}
}
